import { cn } from '@linka/utils';

export function ChartCard({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card'
      className={cn('border border-ctx-layout-border p-xxs rounded-md flex flex-col gap-xxs w-full', className)}
      {...props}
    />
  );
}

export function ChartCardHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot='card-header' className={cn('flex items-center justify-between', className)} {...props} />;
}

export function ChartCardTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot='card-title' className='text-ctx-content-title ts-heading-xs w-full' {...props} />;
}

export function ChartCardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot='card-content' className={cn(className)} {...props} />;
}

export function ChartCardFooter({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot='card-footer' className={cn(className)} {...props} />;
}
